import { render, staticRenderFns } from "./SetDefaultImages.vue?vue&type=template&id=d123d9ee&"
import script from "./SetDefaultImages.vue?vue&type=script&lang=js&"
export * from "./SetDefaultImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports